import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Role } from '../models/role.model';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class RoleService {

    constructor(private http: HttpClient) {
    }

    getAllRoles() {
        return this.http.get<any>(AppConstants.SITE_URL +'role/get_all_roles');
    }
    getAllPermissions() {
        return this.http.get<any>(AppConstants.SITE_URL +'permission/getAllPermission');
    }

    getRoles(role: Role) {
        return this.http.post<any>(AppConstants.SITE_URL +'role/get_roles', role);
    }
    getRole(role: Role) {
        return this.http.post<any>(AppConstants.SITE_URL +'role/get_role', { id: role });
    }

    getRole_permission(role: Role) {
        return this.http.post<any>(AppConstants.SITE_URL +'role/get_role_permission', { id: role });
    }

    saveRole(role) {
        return this.http.post<any>(AppConstants.SITE_URL +'/role/save_role', role);
    }

    deleteRole(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'/role/delete_role', { id: id });
    }
}




// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/role.service.ts